const breakpoint = 768;
// 関数定義 **********************************************************************
const fadeInUp = () => {
  let fadeInTargets = document.querySelectorAll('.js-fadeInUp');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(target,
      {
        y: 30,
        x: 0,
        autoAlpha: 0,
      },
      {
        y: 0,
        x: 0,
        autoAlpha: 1,
        stagger: 0.1,
        duration: 0.8,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        }
      }
    );
  });
}
const fadeIn = () => {
  let OnlyfadeInTargets = document.querySelectorAll('.js-fadeIn');
  OnlyfadeInTargets.forEach((target) => {
    gsap.fromTo(target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: target,
          start: 'top 80%',
        }
      }
    );
  });
}

// p-concept: タイトル→テキストの順で下から現れる
const conceptReveal = () => {
  const section = document.querySelector('.p-concept');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 65%', // セクションがしっかり見えてから発火
      once: true,
    },
  });
  tl.to('.p-concept__heading', {
    y: 0,
    opacity: 1,
    duration: 0.7,
    ease: 'power2.out',
  }).to('.p-concept__text-block', {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: 'power2.out',
    stagger: 0.35, // 1つ目→2つ目のブロックの順で
  }, 0.7); // タイトル終了後にテキスト開始
};

// p-story: title+img同時にふわっと → heading→text 順に下から
const storyReveal = () => {
  const section = document.querySelector('.p-story');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 65%', // セクションがしっかり見えてから発火（スクロールで「もう出ちゃってる」を防ぐ）
      once: true,
    },
  });
  tl.to(['.p-story__title', '.p-story__img'], {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: 'power2.out',
  }).to('.p-story__heading', {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: 'power2.out',
  }, 1).to('.p-story__text', {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: 'power2.out',
    stagger: 0.3,
  }, 1.5); // title+img のあと heading → text の順
};

// p-commitment: titleは左→右（セクション表示時）。各ブロックはスクロールで見えたタイミングで lead→heading→text の順で下から
const commitmentReveal = () => {
  const section = document.querySelector('.p-commitment');
  if (!section) return;

  // タイトル: タイトル要素をトリガーにすると taste/scene と近いスクロール位置で発火（パディングの差を吸収）
  const titleEl = section.querySelector('.p-commitment__title');
  if (titleEl) {
    gsap.to('.p-commitment__title', {
      x: 0,
      opacity: 1,
      duration: 0.7,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: titleEl,
        start: 'top 85%',
        once: true,
      },
    });
  }

  // 各ブロック（item）: そのブロックが表示されたタイミングで body 内を lead→heading→text の順で下から
  document.querySelectorAll('.p-commitment__item').forEach((item) => {
    const body = item.querySelector('.p-commitment__body');
    if (!body) return;
    const targets = body.querySelectorAll('.p-commitment__lead, .p-commitment__heading, .p-commitment__text');
    if (targets.length === 0) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: 'top 82%',
        once: true,
      },
    });
    targets.forEach((el) => {
      tl.to(el, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
      }, '+=0.25');
    });
  });
};

// p-taste: titleは左→右、text（丸い背景）はその場にふわっと
const tasteReveal = () => {
  const section = document.querySelector('.p-taste');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 85%', // セクションがよく見えてから発火し、スクロールでアニメが見えるように
      once: true,
    },
  });
  tl.to('.p-taste__title', {
    x: 0,
    opacity: 1,
    duration: 0.7,
    ease: 'power2.out',
  }).to('.p-taste__text', {
    opacity: 1,
    duration: 0.9,
    ease: 'power2.out',
    stagger: 0.15,
  }, 0.4).to('.p-taste__caption-line', {
    opacity: 1,
    duration: 0.8,
    ease: 'power2.out',
    stagger: 0.35,
  }, 1.6); // テキストのあと、1行ずつふわっと
};

// p-product: title→text の順で（どちらも下から）
const productReveal = () => {
  const section = document.querySelector('.p-product');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 65%',
      once: true,
    },
  });
  tl.to('.p-product__title', {
    y: 0,
    opacity: 1,
    duration: 0.7,
    ease: 'power2.out',
  }).to('.p-product__text', {
    y: 0,
    opacity: 1,
    duration: 0.6,
    ease: 'power2.out',
  }, 0.5);
};

// p-scene: titleは左→右、itemは順番に下から、各itemのtextはitem表示後に遅れて
const sceneReveal = () => {
  const section = document.querySelector('.p-scene');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 85%', // セクションがよく見えてから発火し、スクロールでアニメが見えるように
      once: true,
    },
  });
  tl.to('.p-scene__title', {
    x: 0,
    opacity: 1,
    duration: 0.7,
    ease: 'power2.out',
  });
  document.querySelectorAll('.p-scene__item').forEach((item) => {
    const text = item.querySelector('.p-scene__text');
    tl.to(item, {
      y: 0,
      opacity: 1,
      duration: 0.6,
      ease: 'power2.out',
    }, '+=0.2');
    if (text) {
      tl.to(text, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
      }, '+=0.35'); // item表示後に遅れて
    }
  });
};

// p-spec: top-text を1行ずつふわっと（taste__caption と同じ＝セクション1本の timeline で）
const specReveal = () => {
  const section = document.querySelector('.p-spec');
  if (!section) return;
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top 55%', // taste と同じ
      once: true,
    },
  });
  tl.to('.p-spec__top-text-line', {
    opacity: 1,
    duration: 0.8,
    ease: 'power2.out',
    stagger: 0.35,
  });
};

// 実行 **********************************************************************
document.addEventListener("DOMContentLoaded", function () {
  conceptReveal();
  storyReveal();
  commitmentReveal();
  tasteReveal();
  productReveal();
  sceneReveal();
  specReveal();
  const mm = gsap.matchMedia();
  // SPの時
  mm.add(`screen and (max-width: ${breakpoint - 1}px)`, () => {
    fadeInUp();
  });
  // PCの時
  mm.add(`screen and (min-width: ${breakpoint}px)`, () => {
    fadeInUp();
  });
});
